import { useEffect, useState } from 'react';
import type { FunctionComponent, PropsWithChildren, ReactElement } from 'react';
import styled from 'styled-components';
import valuesIn from 'lodash/valuesIn';
import uniq from 'lodash/uniq';
import map from 'lodash/map';
import filter from 'lodash/filter';
import isString from 'lodash/isString';
import Assets from './assets/Assets';

interface PrerenderedImageProps {
	url: string;
}

const PrerenderedImage = styled.div<PrerenderedImageProps>`
	background: url(${(props) => props.url}) no-repeat;
	display: none;
`;

export interface Props {}

const Preloader: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { children } = props;
	const [prerenderedImages, setPrerenderedImages] = useState<ReactElement[]>(
		[]
	);

	useEffect(() => {
		const prerenderImages = (srcList: string[]): void => {
			setPrerenderedImages(
				map(srcList, (src) => <PrerenderedImage key={src} url={src} />)
			);
		};

		const imageSrcList = uniq(filter(valuesIn(Assets.images), isString));
		prerenderImages(imageSrcList);
	}, []);

	return (
		<>
			{prerenderedImages}
			{children}
		</>
	);
};

export default Preloader;
